import React, { useState, useEffect, useRef } from 'react';
import styles from './kdsPrepStations.module.scss';
import kdsStyles from '../common/KDSCSS/kdsScreens.module.scss'
import cn from 'classnames';
import ExpoTime from '../KdsExpoStationScreens/expoTime';
import moment from 'moment';
import { getObjectValue } from '../../utility/utills';
import Modal from '@components/common/Modal';

const StationCard = ({
  check,
  prepStartAll,
  searchOverlay,
  convertUTCDateToLocalDate,
  themeProperties,
  setSelectedObjects,
  selectedObjects,
  getPrepCompletedTime,
  duplicateDeviceIds,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const deviceInfo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('deviceInfo'), false));
  const columnCount = deviceInfo?.columnCount;
  const kdsSettings = deviceInfo.deviceGroup.kdsSettings;
  const [headerColor, setHeaderColor] = useState('');

  let width = 33;
  if (columnCount) {
    width = 100 / columnCount
  }
  // *****************
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [containerRef.current]);

  const handleScroll = (event) => {
    const container = event.target;
  };

  const handleCheckboxChange = (event, item, checkId) => {
    const selectedObject = { id: checkId }; // create a new object with an id property

    if (event.target.checked) {
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [selectedObject.id]: [...(prevState[selectedObject.id] || []), item] // add the selected object to the array with the corresponding id
        };
      });
    } else {
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [selectedObject.id]: prevState[selectedObject.id].filter(obj => obj.entityId !== item.entityId) // remove the object from the array with the corresponding id
        };
      });
    }

    // log the selected objects array for debugging purposes
  };

  function
    getColor(prepStatus, i) {
    let curTime = new Date().getTime();
    let plannedPrepStartDate = convertUTCDateToLocalDate(new Date(i.plannedPrepStartDate)).getTime();
    if (deviceInfo.deviceGroup?.kdsWarningTime1 != 0 && deviceInfo.deviceGroup?.kdsWarningTime1 != null) {
      if (prepStatus == 2 && curTime >= plannedPrepStartDate) {
        return themeProperties ? 'od-live-orders' : styles.bgGrey
      } else if (prepStatus == 2 && curTime < plannedPrepStartDate) {
        return themeProperties ? 'od-held-orders' : 'color-secondary'
      } else if (prepStatus == 5) {
        return styles.bgBlue
      }
      else if (prepStatus == 8) {
        return styles.bgSuccess
      }
    } else if (prepStatus == 2 && curTime >= plannedPrepStartDate) {
      return themeProperties ? 'od-live-orders' : styles.bgGrey
    } else if (prepStatus == 2 && curTime < plannedPrepStartDate) {
      return themeProperties ? 'od-held-orders' : 'bg-secondary'
    } else if (prepStatus == 5) {
      return styles.bgBlue
    } else if (prepStatus == 8) {
      return styles.bgSuccess
    }
    return styles.bgLightGray
  }

  const individualItemSquare = (prepStatus, i) => {
    let curTime = new Date().getTime();
    let plannedPrepStartDate = convertUTCDateToLocalDate(new Date(i.plannedPrepStartDate)).getTime();
    if (prepStatus == 2 && (i.plannedPrepStartDate === null || curTime < plannedPrepStartDate)) {
      return '#767676'
    } else if (prepStatus == 2 && curTime >= plannedPrepStartDate) {
      return '#767676'
    } else if (prepStatus == 5) {
      return '#0060FF'
    } else if (prepStatus == 8) {
      return '#18BD63'
    } else {
      return '#d1d1d1'
    }
  }

  const onClose = () => {
    setIsOpen(false)
  }

  const checkBoxCheck = (data, id) => {
    if (data != undefined) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.entityId === id) {
          return true
        }
      }
    }
    return false
  }
  const getTime = (date) => {
    if (date === null) {
      return true;
    }
    const momentTime = moment.utc(date).local();
    const currentTime = moment();
    return currentTime > momentTime ? true : false
  }

  const getBuildCompletedTime = (value) => {
    // UTC timings
    var utcTime1 = moment.utc(value.buildStartDate).local();
    var utcTime2 = moment.utc(value.buildCompleteDate).local();

    // Calculate the difference in milliseconds
    var diff = utcTime2.diff(utcTime1);
    // Convert the difference to minutes and seconds
    var duration = moment.duration(diff);
    var minutes = Math.floor(duration.asMinutes());
    var seconds = Math.floor(duration.asSeconds()) % 60;
    // Format the minutes and seconds as 00:00
    var formattedTime = moment.utc().startOf('day').add(minutes, 'minutes').add(seconds, 'seconds').format('mm:ss');

    // // Display the difference time
    return formattedTime
  }

  const getWarningError = (item) => {
    if (item.buildStatus == 5) {
      return true
    }
    const momentTime = moment.utc(item.plannedPrepStartDate).local();
    const currentTime = moment();
    const diffTime = currentTime.diff(momentTime, 'seconds');
    const momentDate = momentTime.format('YYYY-MM-DD');
    let time;
    if (currentTime > momentTime) {
      time = moment(momentDate).startOf('day')
        .seconds(diffTime)
        .format('mm:ss');
    } else {
      time = moment(momentDate).startOf('day')
        .seconds(momentTime.diff(currentTime, 'seconds'))
        .format('mm:ss')
      time = " - " + time;
    }
    var utcTime1 = moment();
    var utcTime2 = moment.utc(item.plannedPrepStartDate).local();
    let t = Math.floor((utcTime1 - utcTime2) / 1000);
    return time.includes('-') ? false : Number(t) > deviceInfo.deviceGroup.kdsWarningTime1 ? true : false
  }
  const getWarningErrorColor = (item) => {
    if (item.prepStatus == 5) {
      if (!item.prepCompleteDate) {
        var utcTime1 = moment();
        var utcTime2 = moment.utc(item.plannedPrepCompleteDate).local();
        let time = Math.floor((utcTime1 - utcTime2) / 1000);
        if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
          return 'yellow'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#F49F40'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#FF6464'
        }
      } else {
        var utcTime1 = moment.utc(item.prepCompleteDate).local();
        var utcTime2 = moment.utc(item.plannedPrepCompleteDate).local();
        // Calculate the difference in milliseconds
        var time = Math.floor((utcTime1 - utcTime2) / 1000);
        if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
          return 'yellow'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#F49F40'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#FF6464'
        }
      }
    }
    if (!item.prepStartDate) {
      var utcTime1 = moment();
      var utcTime2 = moment.utc(item.plannedPrepStartDate).local();
      let time = Math.floor((utcTime1 - utcTime2) / 1000);
      if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
        return 'yellow'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#F49F40'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#FF6464'
      }
    } else {
      var utcTime1 = moment.utc(item.prepStartDate).local();
      var utcTime2 = moment.utc(item.plannedPrepStartDate).local();
      // Calculate the difference in milliseconds
      var time = Math.floor((utcTime1 - utcTime2) / 1000);
      if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
        return 'yellow'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#F49F40'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#FF6464'
      }
    }
    return '';
  }

  const renderItemModifiers = (item, itemId, modPadding) => {
    const modifiers = item?.modifiers?.map((modifierItem, modifierIndex) => {
      return (
        <div key={modifierItem.name + modifierIndex} className={`row mx-0 w-100 ${modifierIndex < item.length - 1 ? 'pb-2' : ''}`} style={{ fontSize: 'max(1.1vw, 1.1vh)', }}>
          <div className="w-10">
            {(modifierItem.plannedPrepStartDate) &&
              <input type='checkbox' style={{ width: '100%' }} className={cn('', styles.checkbox)} onChange={(event) => handleCheckboxChange(event, modifierItem, itemId)} checked={checkBoxCheck(selectedObjects[itemId], modifierItem?.entityId)} disabled={modifierItem.prepStatus === 8} />
            }
          </div>
          {(modifierItem.plannedPrepStartDate) ?
            // <LongPressKds
            //   className={cn("col-6 text-left", kdsStyles?.modifiers)} 
            //   style={{ overflowY: 'scroll', whiteSpace: "nowrap", 
            //     textDecoration: modifierItem.buildStatus === 8 ? "line-through" : '', 
            //     textDecorationColor: 'black', 
            //     color: modifierItem?.allergy ? 'red' : 
            //       getTime(modifierItem.plannedPrepStartDate) ? 'black' : 'gray', 
            //     paddingLeft: modPadding + 'px' 
            //   }}
            //   onLongPress={() => handleLongPress(storeId, modifierItem?.itemId, modifierItem?.name, true)}
            //   onClick={() => { }}
            // >
            <div
              className={cn("col-6 text-left", kdsStyles?.modifiers)} 
              style={{ overflowY: 'scroll', whiteSpace: "nowrap", 
                textDecoration: modifierItem.buildStatus === 8 ? "line-through" : '', 
                textDecorationColor: 'black', 
                color: modifierItem?.allergy ? 'red' : 
                  getTime(modifierItem.plannedPrepStartDate) ? 'black' : 'gray', 
                paddingLeft: modPadding + 'px' 
              }}
            >
              - {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''}&nbsp; {modifierItem.name}
              <div className="text-left pl-2" style={{ color: '#CE842A', fontSize: 'max(1.1vw, 1.1vh)', width: 'max-content' }}>
                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
              </div>
            </div>
            // </LongPressKds> 
            :
            // <LongPressKds
            //   className={cn("col-6 text-left", kdsStyles.modifiers)} 
            //   style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px' }}
            //   onLongPress={() => handleLongPress(storeId, modifierItem?.itemId, modifierItem?.name, true)}
            //   onClick={() => { }}
            // >
            <div
              className={cn("col-6 text-left", kdsStyles.modifiers)} 
              style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px' }}
            >
              -   {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''}&nbsp;{modifierItem.name}
              <div className="text-left pl-2" style={{ fontSize: 'max(1.1vw, 1.1vh)', color: '#CE842A', width: 'max-content' }}>
                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
              </div>
            </div>
            // </LongPressKds>
          }
          {modifierItem.plannedPrepStartDate ?
            <div className="col-md px-1 text-right d-flex justify-content-end align-items-center">
              {getWarningError(modifierItem) && getWarningErrorColor(modifierItem) && <div className='pr-1'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={getWarningErrorColor(modifierItem)}>
                  <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                  <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                  <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                </svg>
              </div>}
              <i className={cn(`fa fa-circle fs-12 fa-rotate-180`)} style={{ color: individualItemSquare(modifierItem.prepStatus, item) }} aria-hidden="true" />
              <span className="ml-1">{modifierItem.prepStatus != 8 ? <ExpoTime date={modifierItem.plannedPrepStartDate} /> : getPrepCompletedTime(modifierItem)}</span>
            </div> : <div className='col-3'></div>}
          {modifierItem?.modifiers && modifierItem?.modifiers?.length > 0 && renderItemModifiers(modifierItem, itemId, modPadding + 10)}
        </div>
      )
    });
    return modifiers;
  }

  const headerColorWarning = (warningColor, headerColor) => {
    switch (warningColor) {
      case '#FF6464': return '#FF6464';
      case '#F49F40': headerColor = headerColor !== '#FF6464' ? '#F49F40' : headerColor;
        break;
      case 'yellow': headerColor = headerColor !== '#FF6464' && headerColor !== '#F49F40' ? 'yellow' : headerColor;
        break;
      case 'gray': headerColor = headerColor !== '#FF6464' && headerColor !== '#F49F40' && headerColor !== 'yellow' && headerColor !== '#18BD63' ? 'gray' : headerColor;
        break;
      default: headerColor = headerColor !== '#FF6464' && headerColor !== '#F49F40' && headerColor !== 'yellow' ? '#18BD63' : headerColor;
        break;
    };
    return headerColor;
  }
  const getheaderColor = (items, headerColor) => {
    items.forEach(item => {
      headerColor = headerColorWarning(item.warningColor, headerColor);
      if (headerColor === '#FF6464') return headerColor;
      if (item?.modifiers?.length > 0) {
        headerColor = getheaderColor(item?.modifiers, headerColor);
      }
    });
    return headerColor;
  }

  const rendercheckItems = (items, isModifier) => {
    const itemData = items.map(item => {
      let modData = [];
      if (item?.modifiers?.length > 0) modData = rendercheckItems(item?.modifiers);
      return { ...item, modifiers: modData, warningColor: !getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? 'gray' : item.prepStatus == 0 && item.buildStatus == 0 ? isModifier ? 'gray' : '#18BD63' : getWarningError(item) ? getWarningErrorColor(item) : '#18BD63', colorCode: getWarningErrorColor(item), errorWarning: getWarningError(item) }
    });
    return itemData;
  }

  const getSortData = (check) => {
    let obj = {};

    check?.forEach((item) => {

      let {seatId} = item;

      if(!kdsSettings?.groupBySeat){
        seatId = 1234;
      }

      if(!obj[seatId]){
        obj[seatId] = []
      }

      obj[seatId].push(item);

    })

    return obj;
    
  }

  return (
    <div id={check[0]?.checkPrep?.checkHeader?.id} data-cards={check[0]?.checkPrep?.checkHeader?.id} key={check[0]?.checkPrep?.checkHeader?.id} className={cn('h-100 w-100', searchOverlay ? styles.opacity : '', styles.p3)}>
      <div className={cn(`bg-white color-black `)} style={{ border: !duplicateDeviceIds[check[0]?.buildDeviceId] ? '2px solid #BCBCBC' : `2px solid ${duplicateDeviceIds[check[0]?.buildDeviceId]}` }} >
        <div className={cn(`fs-12 overflowY od-container-card-background`)} ref={containerRef} style={{ height: '45vw' }} >
          {Object.values(getSortData(check))?.map((el) => {
            return (
              <>
                {kdsSettings?.groupBySeat && el[0]?.seatNumber && 
                  <div className='w-100 text-center fw-500' style={{ backgroundColor: '#FFFADD', border: kdsSettings?.groupBySeat && '2px solid #BEB893', fontSize: '10px' }}>
                    <span>
                      Seat {el[0]?.seatNumber}
                    </span>
                    {
                      el[0]?.seatName && (
                        <span className='ml-1'>
                          ({el[0]?.seatName})
                        </span>
                      )
                    }
                  </div>
                }
                <>
                  {
                    el?.map((item, checkIndex) => {
                      return (
                        <div className="row py-1 mx-0 w-100 od-container-card-background pl-1 pr-1" style={{ borderBottom: checkIndex < check.length - 1 ? '1px solid #C9C9C9' : '' }}>
                          <div className="w-10">
                            <input type='checkbox' style={{ width: '100%' }} className={cn('', styles.checkbox)} onChange={(event) => handleCheckboxChange(event, item, item.checkPrep.id)} checked={checkBoxCheck(selectedObjects[item.checkPrep.id], item.entityId)} disabled={item?.prepStatus === 8} />
                          </div>
                          <div
                            className={cn("col-6 px-1 pb-1", kdsStyles.item)} 
                            style={{ 
                              textDecoration: item?.prepStatus === 8 ? "line-through" : '', 
                              textDecorationColor: 'black', 
                              color: item?.allergy ? 'red' : getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? 'black' : 'gray' 
                            }}
                          >
                            &nbsp;&nbsp;{item?.quantity > 1 ? item?.quantity + 'x' : '1x'}&nbsp;&nbsp;&nbsp;{item.menuItemName ? item.menuItemName : item.name}
                            <div className="text-left pl-2 fs-12" style={{ color: '#CE842A', width: 'max-content' }}>
                              {`${item.comment ? `- ${item.comment}` : ''}`}
                            </div>
                          </div>
                          <div className="col-md px-1 text-right fs-12 d-flex justify-content-end align-items-center" style={{ fontSize: 'max(1.1vw, 1.1vh)' }}>
                            {getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? <>
                              {getWarningError(item) && getWarningErrorColor(item) && <div className='pr-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={getWarningErrorColor(item)}>
                                  <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                                  <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                                  <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                                </svg>
                              </div>}
                              <i className={cn(`fa fa-circle fs-12 fa-rotate-180 ${getColor(item?.buildStatus, check[0])}`)} style={{ color: individualItemSquare(item?.prepStatus, item) }} aria-hidden="true" />
                            </> :
                              <div className={cn('box align-item-center ')} style={{ height: '1rem', width: '0.5rem', marginRight: '0.6rem', marginBottom: '0.1rem' }}>
                                <i className="fa fa-clock" style={{ color: 'black', fontSize: '0.9rem' }}></i>
                              </div>}
                            <span className="ml-1">{item?.prepStatus !== 8 ? <ExpoTime date={item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate} /> : getBuildCompletedTime(item)}</span>
                          </div>
                          {renderItemModifiers(item, item?.checkPrep?.id, 25)}
                        </div>
                      )
                    }) 
                  }
                </>
              </>
            )
          })}
        </div>
        <Modal
          isOpen={isOpen}
          isModalCenter={true} customClass2={styles.maxWidth}
        >
          <div style={{ backgroundColor: 'gray' }}>
            <div className="px-2 py-2 text-right">
              <i
                role="presentation"
                onClick={() => onClose()}
                className="fa fa-times fs-30"
                aria-hidden="true"
              />
            </div>
            <div className='text-center mb-5'>
              <button className='w-50 od-btn-primary btn20 ' style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: 'solid',
                paddingBottom: '22px'
              }} onClick={() => { 
                prepStartAll(check[0], 'build');
                setIsOpen(false) 
                }} >Bump Items</button>

            </div>
          </div>
        </Modal>
      </div>
    </div>

  );
};

export default StationCard;
